import { render, staticRenderFns } from "./EquivalencesTable.vue?vue&type=template&id=3231ed03"
import script from "./EquivalencesTable.vue?vue&type=script&lang=js"
export * from "./EquivalencesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports